import { Loader2 } from "lucide-react";

// Zero-logic landing page for the Apple Sign In popup (usePopup:true).
// Apple loads this page inside the popup after auth, but the authorization
// result is delivered to the *opener* window via the Apple JS SDK — this page
// reads no params and calls no APIs. It exists only to (a) be a valid
// same-origin Return URL registered on the Services ID, and (b) avoid the
// app's catch-all route rendering the full shop inside the popup.
export default function AppleLoginReturn() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
    </div>
  );
}
